import { settingWizardService } from '../_services/setting-wizard.service'
import AppConstants from '../constants/app.constants'

// STATE
const settingWizard = localStorage.getItem(AppConstants.STORAGE_SETTING_WIZARD)
const defaultSettingWizard = {
  // セットアップのデータ
  setupData: {},
  // ユーザ1回でも完全設定完了フラグ
  // 0：未完了、1：完了
  setupStatus: 0,
  // ステータス設定ウィザードパネル
  // 0:非表示、1:表示
  menuStatus: 1
}

const state = {_settingWizard: JSON.parse(settingWizard) || defaultSettingWizard}

// ACTIONS
const actions = {
  async getSetupDataSettingWizard({ commit }, param) {
    const setupData = await settingWizardService.getSettingWizardData((param && param.hubId) || -1)
    commit('setSetupData', setupData)
    commit('setSettingWizardStorage', state['_settingWizard'])
    return setupData
  },
  async updateSetupData({ commit }, param) {
    const wizardStepInfo = await settingWizardService.updateStepInfo(param.hubId || -1, param.step.toString(), param.finishedSetup)
    commit('setSetupData', wizardStepInfo)
    commit('setSettingWizardStorage', state['_settingWizard'])
    return wizardStepInfo
  },
  async updateSetupStatus({ commit }, setupStatusSW) {
    commit('setSetupStatus', setupStatusSW)
    commit('setSettingWizardStorage', state['_settingWizard'])
  },
  async updateMenuStatus({ commit }, menuStatusSW) {
    commit('setMenuStatus', menuStatusSW)
    commit('setSettingWizardStorage', state['_settingWizard'])
  },
  async removeSetupStatusProp({ commit }) {
    commit('deleteSetupStatus')
    commit('setSettingWizardStorage', state['_settingWizard'])
  }
}

// MUTATIONS
const mutations = {
  setSettingWizardStorage(_state, settingWizardStorage) {
    localStorage.setItem(AppConstants.STORAGE_SETTING_WIZARD, JSON.stringify(settingWizardStorage))
  },
  setSetupData(state, setupData) {
    state['_settingWizard']['setupData'] = setupData
  },
  setSetupStatus(state, setupStatus) {
    state['_settingWizard']['setupStatus'] = setupStatus
  },
  setMenuStatus(state, menuStatus) {
    state['_settingWizard']['menuStatus'] = menuStatus
  },
  deleteSetupStatus(state) {
    delete state['_settingWizard']['setupStatus']
  }
}

// GETTERS
const getters = {
  getSetupData() {
    return state['_settingWizard']['setupData']
  },
  getInfoSteps() {
    const setupData = state['_settingWizard']['setupData']
    // 完了したステップのリスト番号を返す
    if (setupData && setupData.mstSetup && setupData.mstSetup.completedSteps) {
      return setupData.mstSetup.completedSteps.split(',').map(item => parseInt(item)).sort()
    }
    return []
  },
  getMenuStatus() {
    return state['_settingWizard']['menuStatus']
  }
}

export const settingWizardStore = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/setting-wizard.module.js